import React from 'react';
import { motion } from 'framer-motion';

import DoctorInfo from '../../HomeSections/DoctorInfo';
import TestimonialCarousel from '../../HomeSections/TestimonialCarousel';
import CounterCard from '../../HomeSections/CounterCard';
import OurServices from '../../HomeSections/OurServices';
import ContactUs from '../../HomeSections/ContactUS';
import BlogsSection from '../../HomeSections/BlogsSection';
import { useDoctorQuery } from '../../../hooks/useDoctorQuery';
import PackagePurchase from '../../HomeSections/Packages';
import LockedDoctor from '../../HomeSections/LockedDoctor';

export default function Home() {
    
    // Animation variants for sections
    const sectionVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: 'easeOut' },
        },
    };
    const { data: doctor } = useDoctorQuery();
    console.log(doctor,"s");
    
 if (doctor?.isLocked) {
      <LockedDoctor/>   
    }
    return (
        <div className="space-y-16">
            <motion.div  variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <CounterCard />
            </motion.div>
            <motion.div id="services" variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <OurServices />
            </motion.div>
            <motion.div id="packages" variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <PackagePurchase />
            </motion.div>
            {/* <hr className='bg-primary/30 h-[1.5px] mx-32'></hr> */}

            <motion.div id="doctor" variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <DoctorInfo />
            </motion.div>
            {/* <hr className='bg-primary/30 h-[1.5px] mx-32'></hr> */}

            <motion.div id="blogs" variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <BlogsSection />
            </motion.div>
            <motion.div id="testimonials" variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <TestimonialCarousel />
            </motion.div>
            <motion.div id="contact" variants={sectionVariants} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                <ContactUs />
            </motion.div>
        </div>
    );
}
